import gql from 'graphql-tag';

// 実績一覧取得
export const GET_SETTLE_RESULT_LIST = gql`
    query (
        $member_no: ID!,
        $limit: Int,
        $offset: Int
    ) {
        GetSettleResultList(
          member_no: $member_no,
          limit: $limit,
          offset: $offset
        )
    {
        SettleResultList {
            settle_no
            reserve_no
            member_no
            play_date
            golf_code
            golf_name
            cell_number
            play_number
            total_amount
            golf_name
        }
        count
        }
    }
`;

export const GET_SETTLE_DETAILS = gql`
    query(
        $settle_no: String!,
        $page_no: Int
    ) {
        GetSettleDetails(
            settle_no: $settle_no,
            page_no: $page_no
        ) {
            Settle {
                settle_no
                reserve_no
                page_no
                receipt_no
                receipt_date
                reserve_date
                holder_no
                member_name
                receipt_amount
                subtotal_amount
                total_amount
                mark_guide
            }
            SettleDetails {
                    page_no
                    item_no
                    item_name
                    unit_price
                    quantity
                    line_amount
                    detail_type
                    calc_type
                    tax_rate
            }
            count
        }
    }
`;

export const PRINT_SPECIFICATION = gql`
    query(
        $settle_no: String!,
        $processing_kbn: Int!
    ) {
        PrintSpecification(
            settle_no: $settle_no,
            processing_kbn: $processing_kbn
        ) {
            result
        }
    }
`;
